import React, { useState, useEffect } from "react";
import client from "network/client";

export default function RegisterForm({
  setToken,
  setIsLoggedIn,
  setPrimaryCalendarId,
  setFlashMessage,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [arePasswordsMatching, setArePasswordsMatching] = useState(true);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (passwordConfirmation === password) {
      setArePasswordsMatching(true);
    } else {
      setArePasswordsMatching(false);
    }
  }, [password, passwordConfirmation]);

  useEffect(() => {
    if (arePasswordsMatching) {
      setErrorMessage("");
    } else {
      setErrorMessage("Passwords do not match");
    }
  }, [arePasswordsMatching]);
  const { post } = client();

  function handleRegisterSubmit(event) {
    event.preventDefault();
    if (arePasswordsMatching) {
      const body = { email, password, passwordConfirmation };
      post({ url: "users", body: body })
        .then((data) => {
          if (data.token) {
            setToken(data.token);
            setPrimaryCalendarId(data.user.data.attributes.primary_calendar_id);
            setFlashMessage({ message: "Welcome to Glass!" });
            setIsLoggedIn(true);
          } else if (data.message) {
            setErrorMessage(data.message.split(":")[1]);
          }
        })
        .catch((error) => {
          console.log(error);
          if (typeof error.json === "function") {
            error.json().then((errorBody) => {
              setErrorMessage(errorBody.message.split(":")[1]);
            });
          } else {
            setErrorMessage(error.message.split(":")[1]);
          }
        });
    }
  }

  return (
    <>
      <h2>Register</h2>
      <div className="auth-error-message">{errorMessage}</div>
      <form onSubmit={handleRegisterSubmit}>
        <label htmlFor="user-register-email" hidden={true}>
          Email
        </label>
        <input
          data-cy="user-register-email"
          type="text"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder="email"
        />

        <label htmlFor="user-register-password" hidden={true}>
          password
        </label>
        <input
          data-cy="user-register-password"
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="password"
        />

        <label htmlFor="user-password-confirmation" hidden={true}>
          password confirmation
        </label>
        <input
          data-cy="user-password-confirmation"
          type="password"
          value={passwordConfirmation}
          onChange={(e) => {
            setPasswordConfirmation(e.target.value);
          }}
          placeholder="password confirmation"
        />

        <input
          type="submit"
          className="auth-submit"
          value="Submit"
          data-cy="register-submit"
        />
      </form>
    </>
  );
}
